<template>
  <div class="wrap">
    <div class="wrapper">

      <div class="login_user">
        <img src="../../assets/images/logo.jpg"
             alt="">
      </div>
      <ul class="formRegister"
          :class="{'iestyle':isIE}">
        <li>
          <div>
            <img src="./img/name.png" class="input-icon" alt="">
            <input type="text"
                   placeholder="请输入姓名"
                   v-model="name">
          </div>
        </li>
        <li>
          <div>
            <img src="./img/email.png" class="input-icon" alt="">
            <input type="text"
                   placeholder="请输入邮箱"
                   v-model="email">
          </div>
        </li>

        <li>
          <div>
            <img src="./img/phone.png" class="input-icon" alt="">
            <input type="text"
                   placeholder="请输入手机号"
                   v-model="phone">
          </div>
        </li>
        <li>
          <div>
            <img src="./img/yz.png" class="input-icon" alt="">
            <input type="text"
                   placeholder="请输入验证码"
                   v-model="phonecode">

          </div>

          <button type="button"
                  @click="getCode"
                  id="code"
                  :disabled="disable">{{code}}</button>
        </li>
        <li>
          <div>
            <img src="./img/shape.png" class="input-icon" alt="">
            <input type="text"
                   placeholder="请输入单位"
                   v-model="org">
          </div>

        </li>
        <!--<li>-->
          <!--<div>-->
            <!--<i class="iconfont">&#xe685;</i>-->
            <!--<input type="text"-->
                   <!--placeholder="请输入职称"-->
                   <!--v-model="post">-->
          <!--</div>-->
        <!--</li>-->
        <!--<li>-->
          <!--<div>-->
            <!--<i class="iconfont">&#xe64e;</i>-->
            <!--<input type="text"-->
                   <!--placeholder="请输入地址"-->
                   <!--v-model="addr">-->
          <!--</div>-->

        <!--</li>-->

      </ul>

      <div class="login">
        <button id="submit_btn"
                @click="register"><span>注册并登录</span></button>

        <p class="tab">
          <router-link :to="{name:'Login'}">已有账号,立即登录</router-link>
        </p>

      </div>

    </div>

  </div>
</template>
<script>
import AppSetting from '../../AppSetting';
import loginService from '../../plugin/extendFn/loginService';

import store from "../../store";

export default {
  data () {
    return {
      name: '',
      phonecode: '',
      org: "", // 单位
      post: '', // 职称
      phone: '', // 电话
      email: '', // 邮箱
      addr: '', // 地址
      wxuser: null,
      source: localStorage.getItem('source'),
      code: '获取验证码',
      disable: false,
      isIE: false,
    }
  },
  props: {},
  methods: {
    //新用户注册
    register () {
      let reg = new RegExp("^[a-zA-Z0-9_\.-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$"); //正则表达式

      if (this.name == '') {
        this.$message.error('请输入姓名！');
        return false;
      }
      if (!reg.test(this.email)) {
        this.$message.error('请输入正确格式的邮箱！！');
        return false;
      }
      if (this.phone == '') {
        this.$message.error('请输入手机号！');
        return false;
      }
      if (this.phonecode == '') {
        this.$message.error('请输入验证码！');
        return false;
      }
      // if (this.org == '') {
      //   this.$message.error('请输入单位！');
      //   return false;
      // }

      let params = {
        identify: this.phonecode,
        phone: this.phone,
        name: this.name,
        org: this.org,
        mail: this.email,
        post: this.post,
        addr: this.addr,
      };

      this.$postHttp(AppSetting.baseUrl + '/student/register', params).then(async (res) => {

        if (res.data.code == 0) {
          await loginService.setLoginUser(res.data.student)
          this.$message({
            message: '登录成功',
            type: 'success'
          });

          setTimeout(() => {
            // window.history.go(-1);
            //注册完成之后跳转行业标签选择页
            this.$router.push({
              name: "Live",
            })
          }, 1000)
        }else if (res.data.code == 1000) {
          this.$message.error(res.data.msg);
        } else if (res.data.code == 2003) {
          this.$message.error('验证码错误！');
        } else if (res.data.code == 2001) {
          this.$message.error('验证码过期！');
        } else if (res.data.code == 2000) {
          this.$message.error('账号不存在，请先完成注册！');
          this.$router.push({
            name: 'Register'
          })
        }else if(res.data.code == 2005){
          this.$message.error('该用户已存在');
        } else {
          this.$message.error('绑定失败');
        }
      })

    },
    getCode () {
      if (this.phone == '') {
        this.$message.error('请输入手机号！');
        return false;
      }

      const obtn = document.getElementById('code');
      obtn.style.color = '#333333';
      //type之前是student 这样传到identify这个接口 一定是 LOGIN oper是干嘛的不知道
      this.$postHttp(AppSetting.baseUrl + '/login/identify', { phone: this.phone, type: 'REG', oper: 'reg' }).then((res) => {
        console.log(res);
        if (res.data.code == 2007) {
          this.$message.error('验证码发送失败!');
        } else if (res.data.code == 0) {
          let num = 59;
          this.code = num + 's后重发';
          this.disable = true;
          let code = setInterval(() => {
            num--;
            this.code = num + 's后重发';
            if (num < 1) {
              this.disable = false;
              // obtn.style.color = '#007EFF';
              this.code = '重新获取';
              clearInterval(code)
            }
          }, 1000)
          // this.toast('验证码发送成功');
        } else if (res.data.code == 2008) {
          this.$message.error('此手机号已被绑定!');
        }
      });
    },

  },
  computed: {},
  async mounted () {
    this.wxuser = await loginService.getLoginUser();
    if (localStorage.getItem('source') == "undefined") {
      this.source = ''
    }

    if (!!window.ActiveXObject || "ActiveXObject" in window) {
      this.isIE = true
    } else {
      this.isIE = false;
    }

  }
}
</script>
<style scoped lang="scss">

.input-icon{
  width:21px;
  margin-right: 10px;
  margin-bottom: 2px;
}

  .tab {
    text-align: center;
    padding-top: 0.2rem;
    font-size: 0.24rem;
    a {
      color: #00468f !important;
    }
  }
.wrap {
  background: #ffffff;
  position: relative;
  min-height: 100vh;
  min-width: 800px;
  overflow: hidden;
  background: url("./img/loginBg.png") no-repeat;
  background-size: cover;
}
.wrapper {
  width: 600px;
  min-height: 600px;
  margin: 40px auto;
  border-radius: 10px;
  border: 5px solid #f0f0f0;
  padding: 20px;
  box-sizing: border-box;
}

.text {
  font-size: 12px;
  width: 400px;
  padding-left: 80px;
  margin-bottom: 20px;
  margin-top: 10px;
  span {
    color: #de0000;
  }
}

.outline {
  border: 1px solid #ffb441 !important;
  > div {
    background: #ffb441;
  }
}
.outline + span {
  color: #333333 !important;
}
.login {
  width: 400px;
  margin: 0 auto;
}
.login_user {
  text-align: center;
  width: 100%;
  background-size: 100% 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  span {
    font-size: 18px;
    font-weight: bold;
    color: #ffffff;
  }
  img {
    width: 150px;
    margin-top: 10px;
    margin-bottom: 30px;
  }
}
.bg {
  width: 100%;
  position: absolute;
  top: 0px;
  bottom: 0px;
  left: 0px;
  background: rgba(0, 0, 0, 0.5);
  z-index: 1;
}
.formRegister {
  font-size: 16px;
  width: 400px;
  margin: 0 auto;
  li {
    div {
      display: flex;
      width: 400px;
      min-height: 30px;
      align-items: center;
    }
    border-bottom: 1px solid #cccccc;
    margin-bottom: 20px;
    display: flex;
    width: 400px;
    align-items: center;
    .iconfont {
      font-size: 22px;
      margin-right: 10px;
    }
    input {
      width: 550px;
      height: 30px;
      color: #333333;
      background: rgba(255, 255, 255, 0);
      /*border:1px solid rgba(204,204,204,1);*/
      border: none;
      border-radius: 10px;
      font-size: 14px;
      /*padding: 0 0.19rem;*/
      outline: none;
      box-sizing: border-box;
    }
    input::placeholder {
      font-size: 14px;
      color: #999999;
    }
  }
   li:nth-of-type(4) {
     border: none;
     div {
       width: 300px;
       border-bottom: 1px solid #cccccc;
      input {
         width: 300px !important;
        padding-right:10px;
        box-sizing: border-box;
      }
     }
   }
  li:nth-last-of-type(1) {
    margin-bottom: 0px !important;
  }

  .codelis {
    input {
      width: 200px !important;
    }
    button {
      margin-left: 20px;
      width: 180px;
      height: 40px;
      background: rgba(255, 255, 255, 1);
      border: 1px solid rgba(204, 204, 204, 1);
      box-sizing: border-box;
      border-radius: 5px;
      font-size: 14px;
      color: #666666;
    }
  }
}
.tab {
  text-align: center;
  padding-top: 10px;
  font-size: 14px;
  a {
    color: #ffb441;
  }
}
.must {
  color: #ff0000;
  font-size: 14px;
}
.formName {
  display: inline-block;
  width: 117px;
  text-align: justify;
  text-align-last: justify;
  text-justify: distribute-all-lines;
  margin-right: 24px;
  white-space: nowrap;
  color: #666666;
}
#code {
  outline: none;
  width: 230px;
  border-bottom: 1px solid #cccccc;
  height: 36px;
  display: inline-block;
  margin-left: 14px;
  background: none;
  border-top: none;
  border-left: none;
  border-right: none;
  color: #333333;
  font-size: 16px;
  cursor: pointer;
}
#submit_btn {
  width: 400px;
  height: 50px;
  /*background:linear-gradient(0deg,rgba(2,130,255,1) 0%,rgba(32,174,255,1) 100%);*/
  background: #00468f;
  color: #ffffff;
  border-radius: 10px;
  font-size: 18px;
  font-weight: 500;
  color: rgba(255, 255, 255, 1);
  margin: 0 auto;
  margin-top: 20px;
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  outline: none;
  cursor: pointer;
}

.iestyle {
  img {
    width: 27px !important;
    height: 18px !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/login/register_pc.vue